import { Component, OnInit, ViewChild } from '@angular/core';

import { AuthService, AppInformationService, ArkUnitOfWork, UtilityService } from 'app/core/core.module';
import { CommitteeMember, Family, Person } from 'app/core/model/entity-model';
import { InputDialogComponent } from 'app/shared/input-dialog/input-dialog.component';
import { DevExtremeModule, DxDataGridComponent } from 'devextreme-angular';
import { confirm, alert } from 'devextreme/ui/dialog';
import moment from 'moment';
import { BsModalService } from 'ngx-bootstrap/modal';
import { FamiliesDetailComponent } from '../families-detail/families-detail.component';
import _ from 'lodash';

@Component({
    selector: 'app-committee-overview',
    templateUrl: './committee-overview.component.html',
    styleUrls: ['./committee-overview.component.scss'],
    imports: [DevExtremeModule]
})
export class CommitteeOverviewComponent implements OnInit {
    committees: any;
    members: any;
    memberSelectedRow: any;
    isCouncil = false;

    statuses: any;
    peopleStatuses: any;
    familyStatuses: any;
    filter: any;
    people: any[];
    givingYears: any;
    canPrintStatement = false;
    readOnly = true;
    isClerk = false;

    historicalData: any;
    showHistory = false;

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
    @ViewChild('memberGrid') memberGrid: DxDataGridComponent;

    constructor(
        private uow: ArkUnitOfWork,
        private auth: AuthService,
        private appInfo: AppInformationService,
        private modalService: BsModalService,
        private utility: UtilityService
    ) {}

    async ngOnInit() {
        this.committees = this.uow.lookups.committees;
        await this.getData();
        this.isClerk = this.auth.hasRole('Executive:Clerk');
        this.readOnly = !this.auth.hasRole('Executive:Clerk') && !this.auth.hasRole('PeopleAdmin');
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                template: 'toolbarText',
                location: 'after',
            }
        );
    }

    async onSelectionChanged(e) {
        await this.getData();
    }

    async onValueChanged(e) {
        if (!this.filter.statusId) return;
        await this.getData();
    }

    async getData() {
        if (!this.dataGrid) return;
        const selectedRow = this.dataGrid.instance.getSelectedRowsData()[0];
        if (!selectedRow) return;

        this.appInfo.pleaseWaitShow();
        this.isCouncil = selectedRow.name === 'Full Council';
        if (this.isCouncil) {
            const members = (await this.uow.getMembersByCommitteeIds([2, 3, 4])) as CommitteeMember[];
            this.members = _.uniqBy(members, 'personId');
        } else {
            this.members = (await this.uow.getMembersByCommitteeId(selectedRow.id, this.showHistory)) as CommitteeMember[];
        }
        this.appInfo.pleaseWaitHide();
    }

    async toggleShowHistory() {
        this.showHistory = !this.showHistory;
        await this.getData();
    }

    async addPerson() {
        const people = (await this.uow.people.all()).map((x) => {
            return {
                id: x.id,
                name: `${x.firstName} ${x.lastName}`,
            };
        });

        const modalRef = this.modalService.show(InputDialogComponent, {
            class: 'modal-sm',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                dialogHeader: 'Add Person',
                dialogPrompt: 'Select Person',
                dialogValueArray: people,
                mode: 'selectWithId',
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.success) {
                const member = this.uow.committeeMembers.createEntity();
                const selectedRow = this.dataGrid.instance.getSelectedRowsData()[0];
                member.committeeId = selectedRow.id;
                member.startDate = new Date();
                member.personId = result.value;
                await this.uow.commit();
                await this.getData();
            }
            modalRef.hide();
        });
    }

    async remove() {
        const selectedRows = this.memberGrid.instance.getSelectedRowsData();
        if (!selectedRows || selectedRows.length === 0) return;

        const result = await confirm(
            `Are you sure you want to remove ${selectedRows.length === 1 ? 'this person' : 'these people'}  from the group?`,
            `${this.appInfo.settings.church}`
        );
        if (!result) return;
        selectedRows.forEach((row) => {
            console.log(row);
            row.endDate = new Date();
        });
        await this.uow.commit();
        await this.getData();
    }

    async assignRole(role: string) {
        const selectedRow = this.memberGrid.instance.getSelectedRowsData()[0];
        if (!selectedRow || selectedRow.length === 0) return;

        this.members.forEach((member) => {
            if (role === 'Clerk') member.clerk = false;
            if (role === 'Chair') member.chair = false;
        });

        if (role === 'Clerk') selectedRow.clerk = true;
        if (role === 'Chair') selectedRow.chair = true;

        await this.uow.commit();
        await this.getData();
    }

    async assignDate(mode: string) {
        const selectedRow = this.memberGrid.instance.getSelectedRowsData()[0];
        if (!selectedRow || selectedRow.length === 0) return;

        const dateValue = mode === 'Start' ? selectedRow.startDate : selectedRow.endDate;
        const modalRef = this.modalService.show(InputDialogComponent, {
            class: 'modal-sm',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                dialogHeader: 'GRAAFSCHAP',
                dialogPrompt: `Enter ${mode} Date`,
                dialogValue: dateValue,
                mode: 'date',
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.success) {
                if (mode === 'Start') selectedRow.startDate = moment(result.value).startOf('day').toDate();
                if (mode === 'End') selectedRow.endDate = moment(result.value).startOf('day').toDate();
                // await this.getData();
                await this.uow.commit();
                await this.getData();
            }
            modalRef.hide();
        });
    }

    async open(data: any) {
        return;
        const modalRef = this.modalService.show(FamiliesDetailComponent, {
            class: 'modal-lgw',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                // family: data.family,
                key: data.familyId,
                showAsDialog: true,
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.success) {
                // await this.getData();
            }
            modalRef.hide();
        });
    }

    async getStatus(statuses: any[]): Promise<number> {
        const modalRef = this.modalService.show(InputDialogComponent, {
            class: 'modal-md',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                dialogHeader: 'Update Status',
                dialogPrompt: 'Select Status',
                dialogValueArray: statuses,
                mode: 'selectWithId',
            },
        });

        const promise = new Promise<number>(async (resolve, reject) => {
            modalRef.content.result.subscribe(async (result) => {
                if (result.success) {
                    resolve(result.value);
                }
                modalRef.hide();
                resolve(null);
            });
        });
        return promise;
    }

    async updateStatus(mode: any) {
        const selectedRows = this.dataGrid.instance.getSelectedRowsData();
        if (!selectedRows) return;

        let statuses = null;
        if (mode === 'Person') statuses = this.uow.lookups.peopleStatuses;
        else if (mode === 'Family') statuses = this.uow.lookups.familyStatuses;

        const selectedStatus = await this.getStatus(statuses);
        if (!selectedStatus) return;
        this.appInfo.pleaseWaitShow();
        const array = selectedRows;
        for (let index = 0; index < array.length; index++) {
            if (mode === 'Person') {
                const person = (await this.uow.people.byId(array[index].id)) as Person;
                person.personStatusId = selectedStatus;
            } else if (mode === 'Family') {
                const family = (await this.uow.families.byId(array[index].familyId)) as Family;
                family.familyStatusId = selectedStatus;
            } else return;
        }

        await this.uow.commit();
        await this.getData();
        this.appInfo.pleaseWaitHide();
    }

    async printHouseholdsReport() {
        await this.utility.printHouseholdsReport();
    }

    async printDirectory(mode?: string) {
        await this.utility.printDirectory(mode);
    }

    async printCommitteeReport() {
        await this.utility.printCommitteeReport();
    }

    async printContactSheet() {
        await this.utility.printContactInfoSheet();
    }
    async printPrayerSheet() {
        await this.utility.printPrayerSheet();
    }
    async printExitGreeters() {
        await this.utility.printExitGreeterSheet();
    }

    async printCommitteeAssignment() {
        const dueDate = await this.getInput('Enter Due Date', 'date', null, new Date());
        if (!dueDate) return;
        await this.utility.printCommitteeAssignment(dueDate);
    }

    async getInput(prompt: string, mode: string, array?: any[], value?: any): Promise<any> {
        let modalRef = this.modalService.show(InputDialogComponent, {
            class: 'modal-sm',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                dialogHeader: 'Graafschap Church',
                dialogPrompt: prompt,
                dialogValueArray: array,
                dialogValue: value,
                mode: mode,
            },
        });
        const promise = new Promise<any>(async (resolve, reject) => {
            modalRef.content.result.subscribe(async (result) => {
                if (result.success) {
                    resolve(result.value);
                }
                modalRef.hide();
                resolve(null);
            });
        });
        return promise;
    }
}
